// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1YxbX","colBig":"styles_colBig__GUNST","colSmall":"styles_colSmall__2E11i"};